import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateFirstPageData,
  getHealthEnquiryAPI,
} from '../../Redux/HealthRedux'; // Redux action

// Image imports
import maleChild from '../../assets/health-member/child_male.png';
import femaleChild from '../../assets/health-member/child_female.png';
import selfMale from '../../assets/health-member/self_male.png';
import selfFemale from '../../assets/health-member/self_female.png';
import spouseMale from '../../assets/health-member/spose_male.png';
import spouseFemale from '../../assets/health-member/spose_female.png';
import parentMale from '../../assets/health-member/parent_male.png';
import parentFemale from '../../assets/health-member/parent_female.png';
import inLawsMale from '../../assets/health-member/inLaw_male.png';
import inLawsFemale from '../../assets/health-member/inLaw_female.png';

const brandColor = '#F6931E';

// Styled Components
const Container = styled.div`
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(rgb(245, 227, 195), rgb(129, 59, 153));
  padding: 35px;
`;

const GlassCard = styled.div`
  width: 90%; /* Increased width */
  max-width: 800px; /* Increased max-width */
  padding: 30px;
  background: #f8f8f8; /* Softer off-white background */
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  color: #333;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Section = styled.div`
  text-align: center;
  margin-bottom: 20px; /* Reduce margin */
`;

const SectionTwo = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns in the first row */
  gap: 15px;
  margin-bottom: 20px;
`;

const SectionThree = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columns in the second row */
  gap: 15px;
`;



const Label = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const OptionContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding: 15px;
  border-radius: 8px;
  border: ${({ selected }) =>
    selected ? `2px solid ${brandColor}` : '2px solid transparent'};
  background: ${({ selected }) => (selected ? '#FFF6E5' : 'transparent')};
  transition: 0.3s;
  position: relative;
  width: 80px;
  color: ${({ selected }) => (selected ? brandColor : 'black')}; /* Change color to black */
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ disabled }) => (disabled ? 'transparent' : '#FFF6E5')};
    border: ${({ disabled }) =>
      disabled ? '2px solid transparent' : `2px solid ${brandColor}`};
  }

  img {
    width: 50px; /* Increased image size */
    height: 50px;
  }

  span {
    margin-top: 6px;
    font-weight: 500;
  }

  .count {
    font-size: 16px;
    font-weight: bold;
    color: ${brandColor};
  }
`;

const StyledButton = styled.button`
  background: transparent;
  border: none;
  padding: 0px 5px;
  cursor: pointer;
  color: ${({ selected }) => (selected ? brandColor : 'black')} !important;
  font-weight: bold;
  border-radius: 4px;
  transition: 0.3s;

  &:hover {
    color: ${brandColor} !important;
  }
`;

const NextButton = styled.button`
  width: 100%;
  padding: 14px;
  background: linear-gradient(45deg, #ff6a3a, ${brandColor});
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.3s ease-in-out;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);

  &:hover {
    transform: translateY(-3px);
    background: linear-gradient(45deg, #ff6a3a, ${brandColor});
    box-shadow: 0 0 20px rgba(255, 87, 51, 0.5);
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
  gap: 15px;
`;

const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  font-size: 15px;
  color: black; /* Dark text for better contrast */
  cursor: pointer;
  gap: 10px;

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    box-sizing: border-box;
    accent-color: ${brandColor};
    cursor: pointer;
    vertical-align: middle;
    margin: 0;
  }
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 5px;
  background-color: transparent;
  padding: 5px;
  border-radius: 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  transition: color 0.3s ease;
  border: 1px solid #F6931E;
`;

const Tab = styled.div`
  padding: 5px 15px;
  font-weight: bold;
  border-radius: 20px;
  cursor: pointer;
  border: 2px solid transparent;
  background-color: ${({ selected }) => (selected ? '#F6931E' : 'transparent')};
  color: ${({ selected }) => (selected ? 'white' : '#F6931E')};
  transition: left 0.4s ease, width 0.4s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:last-child) {
    margin-right: 10px;
  }

  &:hover {
    background-color: ${({ selected }) => (selected ? '#F6931E' : '#FEE7B3')};
  }
`;



const CoverageSelection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [maritalStatus, setMaritalStatus] = useState('single');
  const [selected, setSelected] = useState({
    self: null,
    spouse: null,
    parent: null,
    inLaw: null,
  });

  const [medicalCriticalIllness, setMedicalCriticalIllness] = useState(false);
  const [IsInsurerConsumesAlcoholTobacco, setIsInsurerConsumesAlcoholTobacco] =
    useState(false);

  const [childrenCount, setChildrenCount] = useState({
    male: 0,
    female: 0,
  });
  const [enquiryId, setEnquiryId] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    // Extract enquiryId from the query string
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('enquiryId');
    setEnquiryId(id);
  }, []);

  useEffect(() => {
    if (enquiryId) {
      dispatch(getHealthEnquiryAPI({ enquiryId: enquiryId }));
    }
  }, [enquiryId, dispatch]);

  const septateCombinedRedux = useSelector(
    (state) => state.health.septateCombinedRedux
  );

  useEffect(() => {
    if (septateCombinedRedux) {
      setSelected({
        self: septateCombinedRedux?.insuredMembers?.self?.gender || null,
        spouse: septateCombinedRedux?.insuredMembers?.spouse?.gender || null,
        parent: septateCombinedRedux?.insuredMembers?.parent?.gender || null,
        inLaw: septateCombinedRedux?.insuredMembers?.inLaw?.gender || null,
      });

      setChildrenCount({
        male: septateCombinedRedux?.insuredMembers?.child.filter(
          (child) => child.gender === 'male'
        ).length,
        female: septateCombinedRedux?.insuredMembers?.child.filter(
          (child) => child.gender === 'female'
        ).length,
      });
    }
  }, [septateCombinedRedux]);

  const handleMaritalStatusChange = (status) => {
    setMaritalStatus(status);
    if (status !== 'married') {
      // Clear spouse selection if marital status is not 'married'
      setSelected((prev) => ({ ...prev, spouse: null }));
    }
  };

  

  const handleSelect = (type, value) => {
    // Prevent selecting spouse gender same as self gender and vice versa
    if (type === 'self' && selected.spouse === value) {
      return;
    }
    if (type === 'spouse' && selected.self === value) {
      return;
    }

    setSelected((prev) => ({
      ...prev,
      [type]: prev[type] === value ? null : value,
    }));
  };

  // Helper function to check if option should be disabled
  const isDisabled = (type, value) => {
    if (type === 'self' && selected.spouse === value) return true;
    if (type === 'spouse' && selected.self === value) return true;

    // Disable spouse if marital status is not "married"
    if (type === 'spouse' && maritalStatus !== 'married') {
      return true;
    }
    return false;
  };

  const updateChildCount = (gender, type) => {
    setChildrenCount((prev) => {
      const current = prev[gender];
      return {
        ...prev,
        [gender]: type === 'inc' ? current + 1 : Math.max(current - 1, 0),
      };
    });
  };

  const validateSelectedMembers = (selected, childrenCount) => {
    const errors = {};

    if (maritalStatus === 'married' && !selected.spouse) {
      errors.spouseRequired =
        'Spouse is required if marital status is Married.';
    }

    if (
      !selected.self &&
      !selected.spouse &&
      !selected.parent &&
      !selected.inLaw &&
      childrenCount.male === 0 &&
      childrenCount.female === 0
    ) {
      errors.noSelection = 'Please select at least one member to proceed.';
    }

    return errors;
  };

  const handleNext = () => {
    const errors = validateSelectedMembers(selected, childrenCount);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      window.scrollTo(0, 0);
      alert(errors.spouseRequired || errors.noSelection);
      return;
    }

    setValidationErrors({});
    const insuredMembers = {
      self: selected.self ? { gender: selected.self } : null,
      spouse: selected.spouse ? { gender: selected.spouse } : null,
      parent: selected.parent ? { gender: selected.parent } : null,
      inLaw: selected.inLaw ? { gender: selected.inLaw } : null,
      child: [],
    };

    // Add children to insuredMembers
    for (let i = 0; i < childrenCount.male; i++) {
      insuredMembers.child.push({ gender: 'male' });
    }
    for (let i = 0; i < childrenCount.female; i++) {
      insuredMembers.child.push({ gender: 'female' });
    }

    // Create the selectedMembers object
    const selectedMembers = {
      self: selected.self ? true : false,
      spouse: selected.spouse ? true : false,
      parent: selected.parent ? true : false,
      inLaw: selected.inLaw ? true : false,
      child: Array(childrenCount.male)
        .fill(true)
        .concat(Array(childrenCount.female).fill(true)),
    };

    // Dispatch both objects to Redux
    dispatch(
      updateFirstPageData({
        enquiryId: enquiryId,
        insuredMembers,
        selectedMembers,
        medicalCriticalIllness,
        IsInsurerConsumesAlcoholTobacco,
        userDetail: {
          ...septateCombinedRedux?.userDetail,
          maritalStatus: maritalStatus,
        }
      })
    )
      .then(() => {
        navigate(`/member-details?enquiryId=${enquiryId}`);
      })
      .catch((error) => {
        console.error('Error updating insured members:', error);
      });
  };

  return (
    <Container>
      <GlassCard>
        <Title>Marital Status</Title>
        <TabContainer>
          <Tab
            selected={maritalStatus === 'single'}
            onClick={() => setMaritalStatus('single')}
          >
            Single
          </Tab>
          <Tab
            selected={maritalStatus === 'married'}
            onClick={() => setMaritalStatus('married')}
          >
            Married
          </Tab>
          <Tab
            selected={maritalStatus === 'divorced'}
            onClick={() => setMaritalStatus('divorced')}
          >
            Divorced
          </Tab>
          <Tab
            selected={maritalStatus === 'widow'}
            onClick={() => setMaritalStatus('widow')}
          >
            Widow
          </Tab>
          <Tab
            selected={maritalStatus === 'widower'}
            onClick={() => setMaritalStatus('widower')}
          >
            Widower
          </Tab>
        </TabContainer>

        <Title>Whom do you want to cover?</Title>

        {/* Self */}
        <SectionTwo>
          <Section>
            <Label>Self</Label>
            <OptionContainer>
              <Option
                onClick={() =>
                  !isDisabled('self', 'male') && handleSelect('self', 'male')
                }
                selected={selected.self === 'male'}
                disabled={isDisabled('self', 'male')}
              >
                <img src={selfMale} alt="Self Male" />
                <span>Male</span>
              </Option>
              <Option
                onClick={() =>
                  !isDisabled('self', 'female') &&
                  handleSelect('self', 'female')
                }
                selected={selected.self === 'female'}
                disabled={isDisabled('self', 'female')}
              >
                <img src={selfFemale} alt="Self Female" />
                <span>Female</span>
              </Option>
            </OptionContainer>
          </Section>

          {/* Spouse */}
          <Section>
            <Label>Spouse</Label>
            <OptionContainer>
              <Option
                onClick={() =>
                  !isDisabled('spouse', 'male') &&
                  handleSelect('spouse', 'male')
                }
                selected={selected.spouse === 'male'}
                disabled={isDisabled('spouse', 'male')}
              >
                <img src={spouseMale} alt="Spouse Male" />
                <span>Male</span>
              </Option>
              <Option
                onClick={() =>
                  !isDisabled('spouse', 'female') &&
                  handleSelect('spouse', 'female')
                }
                selected={selected.spouse === 'female'}
                disabled={isDisabled('spouse', 'female')}
              >
                <img src={spouseFemale} alt="Spouse Female" />
                <span>Female</span>
              </Option>
            </OptionContainer>
          </Section>
          <Section>
            <Label>Parents</Label>
            <OptionContainer>
              <Option
                onClick={() => handleSelect('parent', 'male')}
                selected={selected.parent === 'male'}
              >
                <img src={parentMale} alt="Parent Male" />
                <span>Father</span>
              </Option>
              <Option
                onClick={() => handleSelect('parent', 'female')}
                selected={selected.parent === 'female'}
              >
                <img src={parentFemale} alt="Parent Female" />
                <span>Mother</span>
              </Option>
            </OptionContainer>
          </Section>
        </SectionTwo>

        {/* Parents */}
        <SectionThree>
          {/* In-Laws */}
          <Section>
            <Label>In-Laws</Label>
            <OptionContainer>
              <Option
                onClick={() => handleSelect('inLaw', 'male')}
                selected={selected.inLaw === 'male'}
              >
                <img src={inLawsMale} alt="InLaw Male" />
                <span>Father-in-Law</span>
              </Option>
              <Option
                onClick={() => handleSelect('inLaw', 'female')}
                selected={selected.inLaw === 'female'}
              >
                <img src={inLawsFemale} alt="InLaw Female" />
                <span>Mother-in-Law</span>
              </Option>
            </OptionContainer>
          </Section>

          {/* Children */}
          <Section>
            <Label>Children</Label>
            <OptionContainer>
              {/* Male Child */}
              <Option selected={childrenCount.male > 0}>
                <img
                  src={maleChild}
                  alt="Child Male"
                  onClick={() => updateChildCount('male', 'inc')}
                  style={{ cursor: 'pointer' }}
                />
                <span>Male</span>
                <div className="btn-container">
                  <StyledButton
                    selected={childrenCount.male > 0}
                    onClick={() => updateChildCount('male', 'dec')}
                  >
                    -
                  </StyledButton>
                  <span className="count">{childrenCount.male}</span>
                  <StyledButton
                    selected={childrenCount.male > 0}
                    onClick={() => updateChildCount('male', 'inc')}
                  >
                    +
                  </StyledButton>
                </div>
              </Option>

              {/* Female Child */}
              <Option selected={childrenCount.female > 0}>
                <img
                  src={femaleChild}
                  alt="Child Female"
                  onClick={() => updateChildCount('female', 'inc')}
                  style={{ cursor: 'pointer' }}
                />
                <span>Female</span>
                <div className="btn-container">
                  <StyledButton
                    selected={childrenCount.female > 0}
                    onClick={() => updateChildCount('female', 'dec')}
                  >
                    -
                  </StyledButton>
                  <span className="count">{childrenCount.female}</span>
                  <StyledButton
                    selected={childrenCount.female > 0}
                    onClick={() => updateChildCount('female', 'inc')}
                  >
                    +
                  </StyledButton>
                </div>
              </Option>
            </OptionContainer>
          </Section>
        </SectionThree>

        <CheckboxContainer>
          <CheckboxWrapper>
            <input
              type="checkbox"
              id="preExistingDisease"
              checked={medicalCriticalIllness}
              onChange={(e) => setMedicalCriticalIllness(e.target.checked)}
            />
            <span style={{ fontSize: '15px' }}>
              Does the insured have any pre-existing disease?
            </span>
          </CheckboxWrapper>

          <CheckboxWrapper>
            <input
              type="checkbox"
              id="substanceConsumption"
              checked={IsInsurerConsumesAlcoholTobacco}
              onChange={(e) =>
                setIsInsurerConsumesAlcoholTobacco(e.target.checked)
              }
            />
            <span style={{ fontSize: '15px' }}>
              Does the insured consume Alcohol / Tobacco / Gutkha / Pan Masala /
              Cigarettes / Bidi / Cigar?
            </span>
          </CheckboxWrapper>
        </CheckboxContainer>

        <NextButton onClick={handleNext}>Next</NextButton>
      </GlassCard>
    </Container>
  );
};

export default CoverageSelection;